/* eslint-disable @typescript-eslint/naming-convention */
import { useMutation } from '@tanstack/react-query';

import { markAsReadNotification } from '../api/notification';
import { useEnvContext } from '../../modules/EnvProvider';

export default function useMarkAsReadNotification() {
  const { targetEnv } = useEnvContext();

  return useMutation((id: string) => markAsReadNotification(id, targetEnv));
}
